import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';

export default {
  getNavigation() {
    Dispatcher.dispatch({
      actionType: ActionTypes.NAVIGATION_GET,
    });
  }
}
